import * as React from 'react';
import { SheLocation } from '../../../types/location';
import { LocationId } from '../../../../commonv3/types/locations';
import { SelectableLocationCard } from './SelectableLocationCard';

type Props = {
  selectedLocationId?: LocationId;
  currentLocationId?: LocationId;
  currentLocationOnline: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (locationId: LocationId) => any;
  locations: SheLocation[];
  className?: string;
  styleName?: string;
};

export const HomeLocationSelector = ({
  locations,
  selectedLocationId,
  currentLocationOnline,
  currentLocationId,
  onSelect,
  className,
}: Props) => (
  <div className={className}>
    {locations.map((loc) => (
      <SelectableLocationCard
        id={loc.short_name}
        key={loc.id}
        location={loc}
        selected={selectedLocationId == loc.id}
        current={currentLocationId == loc.id}
        onClick={() => onSelect(loc.id)}
      />
    ))}
    <SelectableLocationCard
      id="online"
      location={null}
      selected={selectedLocationId == null}
      current={currentLocationOnline}
      onClick={() => onSelect(null)}
    />
  </div>
);
